export default function CONTENT_IMAGE_SIZE(target="body"){
  const [w,d,l] = [window,document,window.location]
  const init = () => {
    const targets = d.querySelectorAll(target)
    const params = {}
    l.search.substr(1).split('&').map(v => {
      const p = v.split('=')
      params[p[0]] = p[1]
    })
    switch(params.mode){
      case 'list':
      case 'detail':
        break
      default:
        if(!targets.length) break
        Array.prototype.forEach.call(targets,target => {
          target.classList.add('is-cont-top')
        })
    }
  }
  d.addEventListener('DOMContentLoaded', init)
}